import { Card } from '@sumup-oss/circuit-ui';

export default Card;
